import { BaseService } from "./base.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DownloadService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
  }

  public downloadInvoice(invoice) {
    const params = new HttpParams()
      .set("invoiceId", invoice?.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.getUrl("getinvoice"), {
      params,
      responseType: "blob",
    });
  }

  public downloadInvoiceAdmin(invoice) {
    const params = new HttpParams()
      .set("invoiceId", invoice.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.getUrl("getInvoiceByAdmin"), {
      params,
      responseType: "blob",
    });
  }

  public downloadManualInvoice(manualInvoice) {
    const params = new HttpParams()
      .set("manualInvoiceId", manualInvoice.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.setUrl("manualInvoiceDownload"), {
      params,
      responseType: "blob",
    });
  }

  public downloadManualInvoiceAdmin(manualInvoice) {
    const params = new HttpParams()
      .set("manualInvoiceId", manualInvoice.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.setUrl("admin/manualInvoiceDownload"), {
      params,
      responseType: "blob",
    });
  }

  public downloadPrepaidManualInvoice(manualInvoice) {
    const params = new HttpParams()
      .set("manualInvoiceId", manualInvoice.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.getUrl("prepaidManualInvoiceDownload"), {
      params,
      responseType: "blob",
    });
  }

  public downloadPrepaidManualInvoiceAdmin(manualInvoice) {
    const params = new HttpParams()
      .set("manualInvoiceId", manualInvoice.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.setUrl("admin/prepaidManualInvoiceDownload"), {
      params,
      responseType: "blob",
    });
  }

  public downloadNote(note): Observable<any> {
    const params = new HttpParams()
      .set("item", note.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.getUrl("downloadNote"), {
      params,
      responseType: "blob",
    });
  }

  public downloadNoteByAdmin(note): Observable<any> {
    const params = new HttpParams()
      .set("id", note.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.setUrl("downloadNoteByAdmin"), {
      params,
      responseType: "blob",
    });
  }
  public downloadSoundByAdmin(note): Observable<any> {
    const params = new HttpParams()
      .set("id", note.id)
      .set("ver", Math.random().toString());
    return this.http.get(this.setUrl("downloadSoundByAdmin"), {
      params,
      responseType: "blob",
    });
  }
}
